const INITIAL_STATE = {
  chat: false,
  modal: false,
}

const CHAT_SET = Symbol('CHAT_SET')
const MODAL_SET = Symbol('MODAL_SET')

export const userFlowStateActions = {
  CHAT_SET,
  MODAL_SET,
}

export default (state = INITIAL_STATE, { type, payload }) => {
  if (type === CHAT_SET) {
    return {
      ...state,
      chat: payload.value,
    }
  } else if (type === MODAL_SET) {
    return {
      ...state,
      modal: payload.value,
    }
  }

  return state
}
